module.exports = __webpack_public_path__ + "static/media/continuousDiscourse_R.a3b486e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/calibration/continuousDiscourse_R.mp3
// module id = h/h/
// module chunks = 1